import EmptyCart from './EmptyCart';

export default EmptyCart;
